// 产品导航
export const product_nav_text = '良循是一个一站式的医学科研智能辅助平台，其围绕医学科研的全流程，为医学科研人员提供从AI智能检索、全文深度解析、趋势热点分析、临床写作生成、综述标书生成到投稿审查的全方位支持。该平台依托人工智能、知识图谱和多源数据分析技术，帮助用户提升科研效率、优化学术表达、强化成果质量与科研规范管理。'

// 产品分组-子产品  proDescRouter： 产品介绍的路由   link：跳转地址  routeName：本项目跳转  notVip  不需要vip 权限   showAI:显示AI图标
export const  productData = [{
		id: 3,
		show: true,
		moduleName: '智能检索系统',
		childer: [
			{id: 21, appId: 10262, name: '良循AI检索', prop: 'aijs', link: 'https://aijs.qfxuexi.com', proDescRouter:'/aijsDesc', hasInt: true, notVip: false, havePermission: false, showAI: true, icon: 'el-icon-check', moduleName: '智能检索系统',},
			{id: 22, appId: 22, name: 'AI选刊', prop: 'aixk', link: 'https://aixk.qfxuexi.com',  havePermission: false, moduleName: '智能检索系统',},
			{id: 23, appId: 23, name: '疾病研究', prop: 'aixk', link: 'https://disease.qfxuexi.com', havePermission: false, moduleName: '智能检索系统',},
		]
	}, {
		id: 1,
		show: true,
		moduleName: '论文写作与投稿',
		url: require('@img/pages/home/product_module_1.png'),
		img_position: 'right',
		childer: [    // havePermission   有权限     hasInt：显示产品介绍
			{id: 1, appId: 10265, name: '临床论文写作', prop: 'clcScientist', link: 'https://clcScientist.qfxuexi.com', hasInt: false, havePermission: false, showAI: true, icon: 'el-icon-check', moduleName: '论文写作与投稿', introduction: '临床论文写作允许用户上传临床数据集，系统会自动识别可能的研究方向，深入挖掘变量间的关联模式，并结合广泛的文献资料进行语义分析和知识整合，动态生成领域知识图谱。最终，系统将提供一个结构完整、逻辑严谨的学术表达参考框架。'},
			{id: 2, appId: 10266, name: '文献计量写作', prop: 'BibDoc', routeName: 'BibDoc', proDescRouter:'/bibDocDesc' , hasInt: true, havePermission: false, showAI: true, icon: 'el-icon-check', moduleName: '论文写作与投稿', introduction: '文献计量写作支持 PubMed 在线导入和 WOS 数据本地导入。用户可根据研究需求，选择生成科学计量、文献计量、动态主题模型或 BERTopic 分析的学术表达参考。每篇参考均包含系统基于导入数据自动生成的可视化分析图谱。'},
			{id: 3, appId: 10260, name: '投稿审查系统', prop: 'aicheck', link: 'https://aicheck.qfxuexi.com', proDescRouter:'/aicheckDesc' , hasInt: true, havePermission: false, showAI: true, icon: 'el-icon-check', moduleName: '论文写作与投稿', introduction: '投稿审查系统是一款专门为科研投稿设计的智能预审工具，专注于从参考文献规范性、行文逻辑严密性、配图质量和期刊适配度这四个关键方面进行全面评估。系统遵循标准评审流程，在投稿前精确识别潜在问题并提供改进建议，帮助作者提高稿件的整体质量，增强学术表达的严谨性和对目标期刊的适应性。',},
		]
	}, {
		id: 2,
		show: true,
		moduleName: '基金课题辅助',
		url: require('@img/pages/home/product_module_2.png'),
		img_position: 'left',
		childer: [
			{id: 4, appId: 10264, name: '多源数据写作', prop: 'ktb', link: 'https://ktb.qfxuexi.com',proDescRouter:'/ktbDesc', hasInt: true, havePermission: false, showAI: true, icon: 'el-icon-check', moduleName: '基金课题辅助', introduction: '支持多源数据库整合、去重、占比分析和自定义筛选，构建个人研究数据集。基于集成数据，系统可智能生成包含可视化图谱的学术综述，以及科学计量、文献计量、动态主题模型及 BERTopic 分析的结构化学术表达参考。'},
			{id: 6, appId: 10261, name: '课题综述写作', prop: 'aizs', link: 'https://aizs.qfxuexi.com',proDescRouter:'/aizsDesc',hasInt: true, havePermission: false, showAI: true, icon: 'el-icon-check', moduleName: '基金课题辅助', introduction: '输入综述主题后，课题综述写作将集中于科研初期的知识整合阶段，智能解析非结构化的文献资源，自动构建领域知识图谱和证据分级体系，进而生成逻辑清晰、结构完整的综述报告。'},
			{id: 5, appId: 10263, name: '科学假说写作', prop: 'aibs', link: 'https://aibs.qfxuexi.com', proDescRouter:'/aibsDesc', hasInt: true, havePermission: false, showAI: true, icon: 'el-icon-check', moduleName: '基金课题辅助', introduction: '科学假说写作是一款面向科研立项与课题设计的智能支持工具，能够深度解析用户输入的研究意图，结合PubMed等权威文献库进行实时调研与逻辑推演，自动生成结构严谨、论据支撑充分的科学假说表达文案，为项目申报、开题设计或研究规划提供高质量参考。'},
		]
	// }, {
	// 	id: 4,
	// 	show: true,
	// 	moduleName: '科研诚信检测',
	// 	url: require('@img/pages/home/product_module_3.png'),
	// 	img_position: 'right',
	// 	childer: [  // notVip  不需要vip 权限
	// 		{id: 31, name: '实验室(课题组)图片管理系统', routeName: 'ImgMan', hasInt: false, notVip: true, showAI: false, icon: 'el-icon-check', moduleName: '科研诚信检测系统', introduction: '实验室(课题组)图片管理系统是一款专为科研团队研发的智能化图片管理系统，集成库内图片相互查重、库内图片全网比对和投稿前提交自建库查重三大核心查重功能，并支持多级文件夹管理、自动化提取图片与切图、精细化权限控制及图片引用记录与追溯，有效防范因图片管理混乱导致的学术不端风险。'},
	// 		{id: 32, name: '图片查重系统', link: 'https://ccself.yuntsg.com', hasInt: false, notVip: true, showAI: false, icon: 'el-icon-check', moduleName: '科研诚信检测系统', introduction: '图片查重系统支持篇内图片重复比对与全网图片检测。系统依托超10亿张学术图片比对库实现全面覆盖；采用深度学习与特征提取技术，能精准识别经裁剪、旋转、调色等复杂变换的相似图像，同时利用向量单向转化技术确保数据不可逆还原且定时清除，全方位保障检测的精准性与数据安全。'},
	// 		{id: 33, name: '论文数据检测 ', link: 'https://lwjc.qfxuexi.com/', hasInt: false, notVip: true, showAI: false, icon: 'el-icon-check', moduleName: '科研诚信检测系统', introduction: '图片查重系统支持篇内图片重复比对与全网图片检测。系统依托超10亿张学术图片比对库实现全面覆盖；采用深度学习与特征提取技术，能精准识别经裁剪、旋转、调色等复杂变换的相似图像，同时利用向量单向转化技术确保数据不可逆还原且定时清除，全方位保障检测的精准性与数据安全。'},
	// 	]
	},
] 

// 全站包  全站权益包
export const vip_all_moduleName = '综合权益包'

export const vip_user_all_data = {
		type: 1,
		appName: '良循综合包',
		child: [{
			id: 1, name: '1个月', price: '399', priceOri: '450', moonNum: 1
		}, {
			id: 2, name: '1年', price: '4000', priceOri: '4788', moonNum: 12
		}, {
			id: 3, name: '5年', price: '16800', priceOri: '23940', moonNum: 60
		}, {
			id: 4, name: '10年', price: '30000', priceOri: '47880', moonNum: 120
		}]
	}
